<template>
  <div :style="styles.base">
    <div class="ticket" v-if="isShowOriginLotteryNum" :style="countFontStyle">抽奖次数：{{ remainRight }}</div>
    <!--    width: 7.10rem; height: 7.10rem-->
    <img style="width: 100%; position: absolute" :src="backgroundImg" alt/>
    <!-- 此元素结构内无法响应式 -->
    <div :id="id" style="position: relative; margin: auto; height: 100%">
      <div :class="getCss('reward-item-box-dashed')">
        <!-- 编辑界面实际发布不展示 -->
        <template v-for="(item, index) in initLotteryArr">
          <div
            v-if="$isInEditor && !isInPreview"
            ref="box"
            :key="index"
            :style="`border: 2px dashed red;
            color: red;
            --box-width: ${ boxWidthStyle }px;
            --box-height: ${ boxHeightStyle }px;
            --box-marign-bottom: ${ boxMarginBottomStyle }px;
            --box-marign-left: ${ boxMarginLeftStyle }px;`"
          >{{ item }}
          </div>
        </template>
      </div>
    </div>
    <c-base-dialog
      v-model="isShow"
      :option="option"
      @confirm="handelConfirmButtonClick()"
      @close="isShow = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('reward')" :style="rewardStyle">
          <div v-show="showRewardPromptText" :style="rewardPromptTextStyle">{{ rewardPromptText }}</div>
          <div v-if="!!rewardBlank" v-html="rewardBlank"></div>
          <div v-for="(item,index) in packageNames" :key="index" :style="rewardPackageNamesStyle">{{ item }}</div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents, common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import Lottery from '@tencent/ceiba-act-sdk-lottery';

const confirmButtonDefaultType = 'default';// 默认类型
const confirmButtonLinkType = 'link';// 跳转类型

export default {
  name: 'CLotterySquare',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'lottery-square-',

      alertMsg: '',

      initLotteryConfig: {
        total: 8,
        width: 710,
        height: 710,
        sbtnx: 280,
        sbtny: 280,
        sbtnw: 215,
        sbtnh: 215,
        boxw: 215,
        boxh: 215,
        position: '3_3_0,230_3_0,455_2_0,455_230_2,455_455_2,230_455_0,3_455_0,3_230_0',
      },
      initLotteryArr: [1, 2, 3, 8, '开始', 4, 7, 6, 5], // 抽奖虚线内容提示
      isShow: false,
      showRewardPromptText: true,
      packageName: '',
      id: 'lottery',
      packagePositionArr: this.configurationData.packagePosition || [], // 初始化礼包id列表
      lotteryFlowID: this.configurationData.lotteryFlowID || 0, // 初始化抽奖流程
      backgroundImg: this.configurationData.backgroundImg || '', // 初始化抽奖背景图
    };
  },
  computed: {
    packageNames() {
      return this.packageName ? this.packageName.split(',') : [];
    },
    option() {
      const { popHeaderText = '温馨提示', popBackgroundImage, confirmButtonImage } = this.configurationData;
      let dialogBackgroundImage = this.dialogConfig.dialogStyle.backgroundImage;
      if (popBackgroundImage) {
        dialogBackgroundImage = `url(${popBackgroundImage})`;
      }
      let confirmBackgroundImage = this.dialogConfig.confirmStyle.backgroundImage;
      if (confirmButtonImage) {
        confirmBackgroundImage = `url(${confirmButtonImage})`;
      }
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: !!popHeaderText ? popHeaderText : false,
        cancel: false,
        confirm: !!confirmBackgroundImage,
        confirmStyle: {
          ...this.styles?.rewardConfirmButtonStyle ?? {},
          backgroundImage: confirmBackgroundImage,
        },
        dialogStyle: {
          ...this.dialogConfig.dialogStyle,
          backgroundImage: dialogBackgroundImage,
        },
      });
    },
    isShowOriginLotteryNum() {
      return this.configurationData.isShowOriginLotteryNum;
    },
    remainRight() {
      return (
        (this.quaInfo[this.lotteryFlowID]
          && this.quaInfo[this.lotteryFlowID].remain)
        || 0
      );
    },
    countFontStyle() {
      if (!this.styles.topFontStyle) {
        return {};
      }
      return {
        fontFamily: this.styles.topFontStyle.fontFamily,
        fontSize: this.styles.topFontStyle.fontSize,
        color: this.styles.topFontStyle.color,
        fontWeight: this.styles.topFontStyle.fontWeight,
      };
    },
    multiplier() {
      if (this.$isInEditor) {
        return 100;
      }
      const fontSize = this.rootFontSize;
      return fontSize ? parseFloat(fontSize.substring(0, fontSize.length - 2), 3) : 50;
    },
    // 编辑器单个奖励盒子宽度虚线
    boxWidthStyle() {
      let { width: containerWidth } = this.styles.base;
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 3);
        containerWidth = containerWidth * this.multiplier;
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 2);
      }
      const { grayX = 10 } = this.configurationData || {};
      const grayYComX = Math.ceil((grayX / containerWidth) * containerWidth);
      return `${(containerWidth - grayYComX * 2) / 3}`;
    },
    // 编辑器单个奖励盒子高度虚线
    boxHeightStyle() {
      let { height: containerheight, width: containerwidth } = this.styles.base;
      if (containerheight.indexOf('rem') > -1) {
        containerheight = containerheight.substring(0, containerheight.length - 3);
        containerwidth = containerwidth.substring(0, containerwidth.length - 3);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerwidth : containerheight;
        containerheight = containerheight * this.multiplier;
      } else if (containerheight.indexOf('px') > -1) {
        containerheight = containerheight.substring(0, containerheight.length - 2);
        containerwidth = containerwidth.substring(0, containerwidth.length - 2);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerwidth : containerheight;
      }
      const { grayY = 10 } = this.configurationData || {};
      const grayYComY = Math.ceil((grayY / containerheight) * containerheight);
      return `${(containerheight - grayYComY * 2) / 3}`;
    },

    boxMarginLeftStyle() {
      let { width: containerWidth } = this.styles.base;
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 3);
        containerWidth = containerWidth * this.multiplier;
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 2);
      }
      const { grayX = 10 } = this.configurationData || {};
      const grayYComX = Math.ceil((grayX / containerWidth) * containerWidth);
      return grayYComX;
    },

    boxMarginBottomStyle() {
      let { height: containerheight, width: containerwidth } = this.styles.base;
      if (containerheight.indexOf('rem') > -1) {
        containerheight = containerheight.substring(0, containerheight.length - 3);
        containerwidth = containerwidth.substring(0, containerwidth.length - 3);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerwidth : containerheight;
        containerheight = containerheight * this.multiplier;
      } else if (containerheight.indexOf('px') > -1) {
        containerheight = containerheight.substring(0, containerheight.length - 2);
        containerwidth = containerwidth.substring(0, containerwidth.length - 2);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerwidth : containerheight;
      }
      const { grayY = 10 } = this.configurationData || {};
      const grayYComY = Math.ceil((grayY / containerheight) * containerheight);
      return grayYComY;
    },
    rewardPromptText() {
      const { rewardPromptText = '恭喜你获得了' } = this.configurationData;
      return rewardPromptText;
    },
    rewardStyle() {
      const { marginTop = 0, display = 'column', fontSize = 'inherit' } = this.styles.rewardStyle;
      return {
        marginTop,
        display,
        fontSize,
      };
    },
    rewardPackageNamesStyle() {
      const { packageNamesColor } = this.styles.rewardStyle;
      return {
        color: packageNamesColor ? packageNamesColor : this.dialogConfig.dialogStyle.color,
      };
    },
    rewardPromptTextStyle() {
      const { rewardPromptTextColor } = this.styles.rewardStyle;
      return {
        color: rewardPromptTextColor ? rewardPromptTextColor : this.dialogConfig.dialogStyle.color,
      };
    },
    rewardBlank() {
      return this.styles?.rewardStyle?.display === 'flex' ? '&nbsp;' : '';
    },
  },
  watch: {
    // 监听当前游戏game_code
    currentGameCode(val) {
      console.log('val===', val, this.actInfo.game_code, this.currentGameCode);
      this.initLotteryPosition(val);
    },
  },
  created() {
    // 多游戏配置项有值
    if (this.configurationData?.customPackagePosition?.[0]?.packageId) {
      this.initLotteryPosition(this.currentGameCode);
    } else {
      this.initLotteryPosition(false);
    }
    console.log(
      'giftList==',
      this.backgroundImg,
      this.lotteryFlowID,
      this.packagePositionArr,
      this.currentGameCode,
      this.actInfo.game_code,
    );

    this.id = this.getContentId();
  },
  mounted() {
    // setTimeout(() => {
    //   this.UPDATE_GAME_CODE('speedm');
    // }, 5000);
    // setTimeout(() => {
    //   this.UPDATE_GAME_CODE('yxzj');
    // }, 10000);
    console.log('version 1.1.14 lottery square configurationData=', this.configurationData, this.uid, this.$actInfo);
    console.log(' lottery this.styles.base', this.styles.base);
    this.$nextTick(() => {
      let { width: containerWidth, height: containerheight } = this.styles.base;
      console.log('lottery  style  containerWidth containerheight', containerWidth, containerheight);
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 3);
        containerheight = containerheight.substring(0, containerheight.length - 3);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerWidth : containerheight;
        containerWidth = containerWidth * this.multiplier;
        containerheight = containerheight * this.multiplier;
        console.log(
          'lottery style containerWidth containerheight multiplier',
          containerWidth,
          containerheight,
          this.multiplier,
        );
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = containerWidth.substring(0, containerWidth.length - 2);
        containerheight = containerheight.substring(0, containerheight.length - 2);
        // 减去顶部剩余抽奖次数的固定高度
        containerheight = this.isShowOriginLotteryNum ? containerWidth : containerheight;
      }
      // const grayY = parseInt(containerWidth * 0.0, 10);
      // 配置过来的 背景图的横向间隙和纵向间隙 默认是 710px 下的 10px 这个是ceiba 2.0 的规范
      const { grayX = 10, grayY = 10 } = this.configurationData || {};
      // const grayYComX = Math.ceil((grayX / containerWidth) * containerWidth);
      // const grayYComY = Math.ceil((grayY / containerheight) * containerheight);
      // 平台px转换成正确值
      let grayYComX = grayX / 100 * this.multiplier;
      let grayYComY = grayY / 100 * this.multiplier;
      // pc端不做处理
      if (this.deviceMode === 'pc') {
        grayYComX = grayX;
        grayYComY = grayY;
      }
      //  box 的宽度
      const w = Math.ceil((containerWidth - grayYComX * 2) / 3);
      //  box 的高度
      const h = Math.ceil((containerheight - grayYComY * 2) / 3);

      console.log('lottery containerWidth containerheight', containerWidth, containerheight);
      let position = `0_0_0,${w + grayYComX}_0_0,${w * 2 + grayYComX * 2}_0_0,${w * 2 + grayYComX * 2}_${
        h + grayYComY
      }_0,`;
      console.log(
        'lottery gray containerWidth =',
        containerWidth,
        ' containerheight =',
        containerheight,
        'grayX =',
        grayX,
        'grayY =',
        grayY,
        'grayYComX=',
        grayYComX,
        'grayYComY =',
        grayYComY,
        'h, w',
        h,
        w,
      );
      position += `${w * 2 + grayYComX * 2}_${h * 2 + grayYComY * 2}_0,${w + grayYComX}_${
        h * 2 + grayYComY * 2
      }_0,`;
      position += `0_${h * 2 + grayYComY * 2}_0,0_${h + grayYComY}_0`;

      const middleX = Math.ceil((containerWidth - w) / 2);
      const middleY = Math.ceil((containerheight - h) / 2);
      this.initLotteryConfig = {
        total: 8,
        width: containerWidth,
        height: containerheight,
        sbtnx: middleX,
        sbtny: middleY,
        sbtnw: w,
        sbtnh: h,
        boxw: w,
        boxh: h,
        position,
      };
      console.log(' make  lottery this.initLotteryConfig version 1.2.11', this.initLotteryConfig, this.uid);
      this.initialize();
    });
  },

  methods: {
    // 挂载抽奖的容器
    getContentId(targetComponentId) {
      // eslint-disable-next-line no-param-reassign
      targetComponentId = targetComponentId || `${Math.random().toString(36)
        .slice(-10)}_${Math.floor(Math.random() * 10000000)}`;
      return `lottery_id_${targetComponentId}`;
    },
    initialize() {
      this.initLottery();
    },
    initLottery() {
      if (this.$isInEditor) return;
      if (!Lottery) return;
      const self = this;
      console.log(' self.remainRight', self.remainRight, this.isShowOriginLotteryNum);
      const lotteryInstance = new Lottery({
        lighturl: self.configurationData.productImg,
        starturl: self.configurationData.startImg,
        ...self.initLotteryConfig,
        contentId: self.id,
        async onClickRollEvent() {
          console.log('click===', self.packagePositionArr, self.lotteryFlowID, self.backgroundImg);
          // const index1 = self.generateLotteryIndex(2000);
          // lotteryInstance.stopRoll(index1);
          // return
          console.log('clickRoll');
          self.reportClick({
            ceibaComponentId: `${self.cid}`,
            ceibaComponentUid: self.uid,
            ceibaComponentUname: self.uname,
          });
          if (!self.$ast.isAPP() && self.configurationData.forceApp) {
            lotteryInstance.reset();
            return self.$ast.gotoAPP();
          }
          // 登录检测
          if (!self.isLogin) {
            self.$alert({ msg: '请先登录' });
            return;
          }
          // 检测角色绑定
          if (
            self.actInfo.extendConfig.forceRole
            && !self.isRoleReady
            && self.isRoleStatusValid) {
            lotteryInstance.reset();
            try {
              baseComponents.gameRoleSelect.showGameRoleSelect(self.currentGameCode, {}).then((roleInfo) => {
                console.log('store select role=', roleInfo);
                self.$store.dispatch('saveCurrentRole', {
                  isRoleReady: true,
                  roleInfo,
                });
              });
            } catch (e) {
              console.error('showGameRoleSelect fail| err=', e);
            }
            return;
          }

          if (self.isShowOriginLotteryNum && self.remainRight <= 0) {
            lotteryInstance.reset();
            self.alert('抽奖次数不足');
            return;
          }
          // 前置钩子：app, 登录校验，上报，参数校验等
          if (
            !(await self.doHook({
              name: 'before_lottry',
            }))
          ) {
            lotteryInstance.reset();
            return;
          }
          const costTimes = self.configurationData?.costTimes ? parseInt(self.configurationData?.costTimes, 10) : 1;
          const response = await self.flowRequest({
            flowId: self.lotteryFlowID,
            params: {
              role: self.roleInfo,
              data: JSON.stringify({
                costTimes,
                gid: self.currentGid,
              }),
            },
          });

          await self.doHook({
            name: 'after_lottery',
            options: {
              meta: self.meta,
              configurationData: self.configurationData,
              response,
            },
          }); // 后置动作，上报等
          console.log('response=', response);
          // 第一层报错
          const { ret: rspRet, msg: rspMsg } = response;
          if (rspRet !== 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            lotteryInstance.reset();
            // 弹窗提示，上报
            self.alert(rspMsg);
            self.refreshQua();
            return;
          }
          // 为了兼容 部分发货后发优惠券的条件机写错的字段【packageId】
          const { ret, package_id = 0, packageId = 0, msg } = response.data || {};
          let  getPackageId = package_id || packageId;
          getPackageId = parseInt(getPackageId, 10) || 0;
          // 第二层报错
          if (ret !== 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            lotteryInstance.reset();
            // 弹窗提示，上报
            self.alert(msg);
            self.refreshQua();
            return;
          }
          // 什么都没有领取成功
          if (getPackageId === 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            lotteryInstance.reset();
            // 弹窗提示，上报
            self.alert(msg);
            self.refreshQua();
            return;
          }
          self.reportClickRaw({
            ceibaComponentId: `${self.cid}`,
            ceibaComponentUid: self.uid,
            ceibaComponentUname: self.uname,
            eventKey: 'lottery',
            eventData: {
              gift_id: getPackageId || '',
              status: '1',
            },
          });
          const index = self.generateLotteryIndex(getPackageId);
          if (index !== -1) {
            self.packageName = response.data.msg.replace('恭喜您获得了礼包： ', '');
            console.log('self.packageName===', self.packageName, self.packageName.length, typeof self.packageName !== 'undefined' && self.packageName.indexOf('谢谢参与') > -1);
            if (typeof self.packageName !== 'undefined' && self.packageName.indexOf('谢谢参与') > -1) {
              self.showRewardPromptText = false;
            }
            return lotteryInstance.stopRoll(index);
          }
          self.packageName = '领取礼包成功';
          lotteryInstance.reset();
          self.refreshQua();
        },
        onCompleteRollEvent() {
          self.isShow = true;
          self.refreshQua();
        },
      });
      console.log('lottery=', lotteryInstance);
    },
    generateLotteryIndex(packageId) {
      // eslint-disable-next-line max-len, vue/max-len
      return this.packagePositionArr.findIndex(item => item.packageId
        .split(',')
        .map(num => parseInt(num, 10))
        .indexOf(parseInt(packageId, 10)) > -1);
    },
    // 确认按钮点击逻辑
    handelConfirmButtonClick() {
      const { confirmButtonType = confirmButtonDefaultType, confirmButtonLink } = this.configurationData;
      // 默认
      if (confirmButtonType === confirmButtonDefaultType) this.isShow = false;
      // 跳转
      if (confirmButtonType === confirmButtonLinkType) {
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        window.location.href = common.tool.passThroughUrlParam(confirmButtonLink, ['via', 'trace_id', 'via_source']);
      }
    },
    // 初始化奖池信息
    initLotteryPosition(flag) {
      const giftList = [];
      // 多游戏
      if (flag) {
        const itemArr = this.configurationData?.customPackagePosition?.find(item => item.multiGameCode === flag) || [];
        console.log('val=====arr', itemArr);
        itemArr?.packageId?.split('|')?.map((item, index) => giftList.push({ packageId: item, index }));
        this.packagePositionArr = giftList || [];
        this.lotteryFlowID = itemArr?.multiGameflowId || 0;
        this.backgroundImg = itemArr?.multiGameBackgroundImage || '';
        console.log('giftList', this.backgroundImg, this.lotteryFlowID, this.packagePositionArr);
      }
      // 默认单游戏
      if (!flag) {
        this.packagePositionArr = this.configurationData.packagePosition || []; // 初始化礼包id列表
        this.lotteryFlowID = this.configurationData.lotteryFlowID || 0; // 初始化抽奖流程
        this.backgroundImg = this.configurationData.backgroundImg || ''; // 初始化抽奖背景图
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.ticket {
  color: #fff;
  line-height: 0.45rem;
  text-align: center;
  margin-bottom: 0.4rem;
  font-size: 0.25rem;
}
</style>
